import React from 'react';
import { BsTrash } from 'react-icons/bs';

export default function DeleteConfirmModal({ name, onConfirm, onCancel, error }) {
  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1060, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="delete-modal-title"
      aria-describedby="delete-modal-desc"
    >
      <div style={{ background: '#fff', borderRadius: '10px', padding: '32px 28px', maxWidth: '380px', width: '90%', boxShadow: '0 8px 32px rgba(0,0,0,0.18)' }}>
        <div style={{ width: 48, height: 48, borderRadius: '50%', background: '#fdecea', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
          <BsTrash size={20} color="#c0392b" />
        </div>
        <h4 id="delete-modal-title" style={{ textAlign: 'center', fontSize: 17, fontWeight: 700, color: '#2c2c2c', margin: '0 0 8px' }}>Delete Configuration?</h4>
        <p id="delete-modal-desc" style={{ textAlign: 'center', fontSize: 13, color: '#666', margin: '0 0 16px' }}>
          <strong style={{ color: '#333' }}>"{name}"</strong> will be permanently removed.
        </p>
        {error && (
          <div className="alert alert-danger py-2 text-center" style={{ fontSize: 13, marginBottom: 16 }}>
            {error}
          </div>
        )}
        <div style={{ display: 'flex', gap: 12 }}>
          <button
            type="button"
            className="btn btn-outline-secondary"
            style={{ flex: 1 }}
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger"
            style={{ flex: 1 }}
            onClick={onConfirm}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}
